export const chatBot = {
  abortedResponse: "The response has been aborted.",
  avatar: "Avatar of Chatbot",
  errorMessage: "Sorry, an error has occurred. Please try again.",
  errorMessageSend: "An error occurred while sending the message.",
  errorMessageUnexpectedError: "An unexpected error has occurred.",
  inputPlaceholder: "Ask your question",
  openButtonLabel: "Open Assistant",
  sendButtonLabel: "Send",
  title: "Xentral AI Assistant",
  today: "Today, ",
  welcomeMessage: "Hello! How can I help you?",
  explainErrorButtonLabel: "Understand this error",
  explainErrorTemplate:
    "The following error message occurred: '{error}'. Explain this and tell me how to fix it."
};
